export const tc = {
  brand: { title: 'CCBC 後台', subtitle: '控制台' },
  navigation: {
    dashboard: '總覽',
    admins: '管理員管理',
    'tithe-receipts': '奉獻收據管理',
    members: '會友管理',
    'minor-members': '少年兒童牧區',
    'serve-positions': '事奉崗位',
    organization: '組織架構',
    events: '聚會 / 活動',
    attendance: '出席記錄',
    'attendance-member': '所有出席記錄',
    check_in: 'QR 報到',
    continuous_checkin: '連續報到掃描',
    joomla: 'Joomla 文章',
    posts: '文章管理',
    'access-control': '權限設定',
    'room-booking': '房間預訂',
    forms: '表單',
    pos: '迷你 POS',
    settings: '系統設定'
  },
  navigationDesc: {
    dashboard: '平台統計與動態總覽',
    admins: '管理後台帳號與權限',
    posts: '建立、編輯並管理文章',
    events: '管理活動與分班時段',
    attendance: '查看與管理報到記錄',
    'attendance-member': '列出所有出席記錄',
    check_in: '掃描 QR Code 進行報到',
    continuous_checkin: '連續掃描多個 QR Code 報到',
    joomla: '查看並監察 Joomla 文章',
    'access-control': '設定使用者權限與存取',
    members: '管理會友資料與角色',
    'serve-positions': '管理教會的事奉崗位和同工分配',
    organization: '檢視與維護組織架構',
    'tithe-receipts': '管理奉獻收據開立與記錄',
    'room-booking': '管理房間預訂與使用狀況',
    forms: '建立、管理及查閱自訂表單',
    pos: '銷售禮品、書籍與課程',
    settings: '系統設定與危險維護操作'
  },
  settings: {
    title: '系統設定',
    description: '平台維護與系統級操作。以下操作不可復原，請謹慎使用。',
    dangerZone: {
      title: '危險區域',
      description: '勾選要整批刪除的分類。只會刪除已勾選的資料，其餘分類和管理員帳號會保留。此操作無法復原。',
      selectAll: '全選',
      button: '刪除已勾選分類',
      noneSelected: '請先勾選最少一個分類',
      categories: {
        members: '會友（責任／友誼／臨時）',
        minor_members: '兒童／少年',
        organization: '組織架構（牧區、區、小組、組員分配）',
        serve_positions: '事奉崗位及同工分配',
        attendance: '出席／報到記錄',
        events: '活動、班別及報名',
        tithe: '奉獻收據',
        forms: '表單及提交',
        pos: 'POS 商品及訂單',
        rooms: '場地及預訂',
        posts: '文章'
      }
    },
    clear: {
      confirmTitle: '確認刪除已勾選分類？',
      confirmBody: '將永久刪除：{{categories}}。未勾選的分類和管理員帳號會保留，而且無法復原。',
      continue: '繼續',
      finalTitle: '最後確認',
      finalBody: '這是最後一步。已勾選的分類將被永久刪除。',
      typePrompt: '請輸入',
      finalButton: '永久刪除已勾選分類',
      clearing: '刪除中...',
      successTitle: '刪除完成',
      successMsg: '已刪除已勾選分類，共 {{count}} 行。',
      errorTitle: '清除失敗',
      errorMsg: '清除資料時發生錯誤，資料庫已回復原狀。',
      resultTitle: '清除結果',
      resultMeta: '由 {{username}} 於清除操作中刪除，共 {{count}} 行。',
      resultTable: '資料表',
      resultRows: '刪除行數',
      resultPreserved: '保留嘅資料表（未清除）：'
    }
  },
  status: { online: '在線' },
  actions: { logoutConfirm: '確定要登出嗎？', logout: '登出' },
  language: { label: '語言', en: 'English', 'zh-TW': '繁體中文' },
  loading: { loading: '載入中...' },
  login: {
    title: 'CCBC 後台系統',
    subtitle: '請登入後台帳號',
    username: '帳號',
    password: '密碼',
    usernamePlaceholder: '輸入您的帳號',
    passwordPlaceholder: '輸入您的密碼',
    submit: '登入',
    submitting: '登入中...',
    loggingIn: '登入中...',
    footer: '© 2025 CCBC Project. 版權所有'
  },
  common: {
    na: '無',
    back: '返回',
    edit: '編輯',
    delete: '刪除',
    save: '儲存',
    cancel: '取消',
    close: '關閉',
    successTitle: '成功',
    errorTitle: '錯誤'
  },
  member: {
    detail: {
      title: '會友詳細資料',
      backShort: '返回',
      backToList: '返回會友列表',
      loadingData: '正在載入會友資料...',
      failedToLoad: '載入會友資料失敗，請再試一次。',
      notFound: '找不到會友資料',
      confirmDelete: '確定要刪除 {{name}} 嗎？此動作無法復原。',
      successDeleteTitle: '成功',
      successDeleteMsg: '已成功刪除會友。',
      errorDeleteTitle: '錯誤',
      errorDeleteMsg: '刪除會友失敗，請再試一次。',
      personalInfo: '個人資訊',
      gender: '性別：',
      dob: '出生日期：',
      idNumber: '身份證號碼：',
      nickname: '暱稱：',
      maritalStatus: '婚姻狀況：',
      occupation: '職業：',
      contactInfo: '聯絡資訊',
      mobile: '手機：',
      email: '電郵：',
      address: '住址：',
      membershipInfo: '會籍資訊',
      membershipType: '會籍狀態：',
      memberRole: '會友角色：',
      joinDate: '加入日期：',
      transferDate: '轉會日期：',
      baptismDate: '受浸日期：',
      baptismPlace: '受浸教會：',
      baptismNo: '會友編碼：',
      baptistPriest: '施浸牧師：',
      baptismClass: '受浸屆別：',
      belongingDistrict: '所屬牧區：',
      belongingZone: '所屬分區：',
      emergencyContact: '緊急聯絡人',
      contactName: '聯絡人姓名：',
      contactPhone: '聯絡人電話：',
      relationship: '關係：',
      additionalNotes: '其他備註',
      created: '建立時間：',
      lastUpdated: '最後更新：',
      worshipNo: '崇拜編碼',
      belongingGroup: '所屬小組：',
      groupRole: '小組崗位：',
      breadcrumb: '會友管理',
      roleRegular: '責任會友',
      roleAssociate: '友誼會友',
      roleTemporary: '臨時會友',
      statusActive: '啟用',
      statusInactive: '停用',
      statusSuspended: '停權'
    },
    tabs: {
      fullMember: '責任會友',
      associate: '友誼會友',
      temporary: '臨時會友'
    },
    upgrade: {
      button: '變更會員身份',
      title: '變更會員身份: {{name}}',
      memberType: '會友類型',
      worshipId: '崇拜編碼',
      worshipIdPlaceholder: '請輸入崇拜編碼',
      worshipIdRequired: '請輸入崇拜編碼',
      confirm: '確認',
      upgrading: '更新中...',
      success: '{{name}} 會友類型已更新！',
      error: '更新會友類型失敗'
    },
    list: {
      title: '會友管理',
      add: '新增會友',
      searchPlaceholder: '以姓名、崇拜編碼、手機或電郵搜尋...',
      statusAll: '全部狀態',
      statusActive: '啟用',
      statusInactive: '停用',
      statusSuspended: '停權',
      loading: '正在載入會友...',
      error: '載入會友失敗，請再試一次。',
      retry: '重試',
      table: {
        worship: '崇拜編碼',
        nickname: '暱稱',
        nameChi: '中文姓名',
        nameEng: '英文姓名',
        gender: '性別',
        role: '身分角色',
        group: '所屬小組',
        zone: '所屬分區',
        district: '所屬牧區',
        mobile: '手機',
        email: '電郵',
        status: '狀態',
        joinDate: '加入日期',
        actions: '操作'
      },
      empty: '沒有會友資料。',
      view: '查看',
      edit: '編輯',
      delete: '刪除',
      confirmDelete: '確定要刪除 {{name}} 嗎？',
      deleteSuccess: '已成功刪除會友！',
      deleteError: '刪除會友失敗，請再試一次。',
      deleteModal: {
        title: '確認刪除會友',
        warning: '警告：此操作無法復原！',
        message: '您即將永久刪除會友「{{name}}」及所有相關記錄。',
        instruction: '請輸入 "delete" 以確認刪除：',
        placeholder: '輸入 delete',
        mismatch: '請輸入正確的確認文字'
      },
      pagination: {
        showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆會友',
        previous: '上一頁',
        next: '下一頁',
        pageOf: '第 {{page}} / {{total}} 頁'
      },
      export: {
        button: '匯出全部',
        success: '已成功匯出會友資料',
        error: '匯出會友失敗'
      },
      template: {
        button: '下載範本',
        downloaded: '已成功下載範本',
        error: '下載範本失敗'
      },
      import: {
        button: '批量匯入',
        importing: '匯入中...',
        success: '匯入完成：已建立 {{created}} 筆，已更新 {{updated}} 筆，{{errors}} 筆錯誤',
        error: '匯入會友失敗',
        invalidFileType: '請選擇 CSV 檔案',
        emptyFile: 'CSV 檔案沒有資料',
        confirm: {
          title: '確認批量匯入',
          message: '請確認以下匯入資料後再繼續：',
          totalRows: '總資料筆數',
          toCreate: '新增會友',
          toUpdate: '更新（崇拜編碼已存在）',
          confirm: '確定加入',
          cancel: '取消'
        }
      }
    },
    form: {
      createTitle: '新增會友',
      editTitle: '編輯「{{name}}」',
      cancelConfirm: '確定要取消嗎？未儲存的變更將會遺失。',
      successCreate: '已成功建立會友！',
      successUpdate: '已成功更新會友！',
      save: '儲存',
      saving: '儲存中...',
      cancel: '取消',
      showAdvanced: '顯示更多詳細資料（地址、教育、小組、健康等）',
      hideAdvanced: '隱藏更多詳細資料（地址、教育、小組、健康等）',
      showAdvancedShort: '展開更多',
      hideAdvancedShort: '收起',
      updateAction: '更新會友',
      createAction: '建立會友',
      sections: {
        basic: '基本資料',
        contact: '聯絡方式',
        address: '地址',
        postalAddress: '郵寄地址',
        membership: '會籍',
        education: '教育',
        family: '家庭',
        occupation: '職業',
        baptism: '受浸',
        religion: '信仰背景',
        service: '事奉',
        cellGroup: '小組',
        health: '健康',
        emergency: '緊急聯絡人',
        communication: '其他電話',
        remarks: '備註',
        otherPhones: '其他電話（選填）'
      },
      labels: {
        worshipId: '崇拜編碼',
        autoWorshipId: '自動產生',
        octopusCardNumber: '八達通卡號碼',
        status: '狀態 *',
        chiName: '中文姓名 *',
        engName: '英文姓名',
        nickname: '暱稱',
        gender: '性別',
        dob: '出生日期',
        hkid: '身份證號碼',
        nativePlace: '籍貫',
        mobile: '手機',
        email: '電郵',
        telDay: '日間電話',
        telNight: '夜間電話',
        companyTel: '公司電話',
        fax: '傳真',
        addr: '地址（完整）',
        addrDistrict: '地區',
        region: '地區/區域',
        street: '街道',
        estate: '屋苑',
        building: '大廈',
        unitNumber: '單位/門牌',
        postalAddr: '郵寄地址',
        statusActive: '啟用',
        statusInactive: '停用',
        statusSuspended: '停權',
        dateOfJoin: '加入日期',
        dateOfJoinAdd: '再次加入日期',
        dateOfTransferAdd: '轉會日期',
        eduGrade: '教育程度',
        eduName: '學校／教育機構',
        marriedStatus: '婚姻狀況',
        dateOfMarried: '結婚日期',
        childQty: '子女數目',
        job: '職業',
        income: '收入',
        workRegion: '工作地區',
        proQual: '專業資格',
        dateOfBaptism: '受浸日期',
        baptismChurch: '受浸教會',
        baptismNo: '會友編碼',
        baptistPriest: '施浸牧師',
        baptismAppointment: '受浸屆別',
        religion: '宗教',
        everChurch: '曾經教會',
        believeDate: '決志日期',
        servePosts: '事奉崗位',
        serveExp: '事奉經驗',
        cellGroup1: '小組',
        cellGroup2: '分區（自動）',
        cellGroup3: '牧區（自動）',
        cellGroup4: '其他小組',
        selectGroup: '選擇小組',
        health: '健康',
        healthItems: '健康詳情',
        emergencyPerson: '緊急聯絡人',
        emergencyTel: '緊急聯絡電話',
        emergencyRelation: '關係',
        receiveInfo: '願意接收資訊',
        remark: '備註',
        remark2: '備註 2'
      },
      placeholders: {
        worshipId: '例：170074 或 T170074',
        octopusCardNumber: '例：012-345-678-9',
        statusFormat: '格式：正式會員 (170074) 或臨時會員 (T170074)',
        emergencyRelation: '例如：配偶、父母、兄弟姊妹',
        remark: '其他備註或說明...',
        eduGrade: '例如：中學、大學、碩士',
        eduName: '例如：某某中學／某某大學'
      },
      hints: {
        addressStructured: '請填寫以下住址欄位；完整地址會自動組合，無需重複輸入。',
        groupAutoOrg: '選擇小組後，分區及牧區會自動帶出。',
        zoneLeaderOrg: '此會友為區長，小組顯示為 NA。',
        districtPastorOrg: '此會友為區牧，小組及分區顯示為 NA。',
        otherPhones: '日間／夜間電話為選填，與上方手機／電郵分開。'
      },
      options: {
        genderSelect: '選擇性別',
        genderMale: '男',
        genderFemale: '女',
        genderOther: '其他',
        maritalSelect: '選擇婚姻狀況',
        maritalSingle: '單身',
        maritalMarried: '已婚',
        maritalDivorced: '離婚',
        maritalWidowed: '喪偶'
      },
      errors: {
        load: '載入會友資料失敗，請再試一次。',
        save: '儲存會友失敗，請再試一次。'
      }
    }
  },
  access: { deniedTitle: '無權限', deniedDescription: '您沒有權限存取此區域。' },
  admin: {
    secureNotice: '安全管理區域 - 所有 API 呼叫均以 Bearer 驗證保護',
    headerTitle: '管理員管理',
    headerSubtitle: '管理管理員與其權限',
    list: {
      addNewAdmin: '新增管理員',
      errorLoading: '載入管理員時發生錯誤',
      searchPlaceholder: '搜尋管理員...',
      perPage: '每頁 {{count}} 筆',
      table: {
        admin: '管理員',
        email: '電子郵件',
        status: '狀態',
        permissions: '權限',
        created: '建立時間',
        actions: '操作',
        active: '啟用',
        inactive: '停用',
        permissionsCount: '{{count}} 項權限',
        modulesCount: '{{count}} 個模組'
      },
      empty: '目前沒有管理員。',
      emptySearch: '找不到符合搜尋條件的管理員。',
      manage: '管理',
      delete: '刪除',
      confirmDelete: '確定要刪除此管理員嗎？',
      notifications: {
        deleteSuccess: '已成功刪除管理員',
        deleteError: '刪除管理員失敗'
      },
      pagination: {
        showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆管理員',
        previous: '上一頁',
        next: '下一頁'
      }
    },
    export: {
      button: '匯出全部',
      tooltip: '匯出所有管理員至 CSV 檔案',
      success: '已成功匯出管理員',
      error: '匯出管理員失敗'
    },
    template: {
      button: '下載範本',
      tooltip: '下載 CSV 匯入範本',
      downloaded: '已成功下載範本',
      error: '下載範本失敗'
    },
    import: {
      button: '批量匯入',
      tooltip: '從 CSV 檔案匯入管理員',
      importing: '匯入中...',
      success: '匯入完成：已建立 {{created}} 筆，已更新 {{updated}} 筆，{{errors}} 筆錯誤',
      error: '匯入管理員失敗',
      invalidFileType: '請選擇 CSV 檔案',
      emptyFile: 'CSV 檔案沒有資料',
      confirm: {
        title: '確認批量匯入',
        message: '請確認以下匯入資料後再繼續：',
        totalRows: '總資料筆數',
        toCreate: '新增管理員',
        toUpdate: '更新（帳號已存在）',
        confirm: '確定加入',
        cancel: '取消'
      }
    },
    form: {
      title: '建立新管理員',
      username: '帳號',
      email: '電子郵件',
      firstName: '名',
      lastName: '姓',
      password: '密碼',
      passwordPlaceholder: '輸入安全密碼（至少 6 碼）',
      usernamePlaceholder: '輸入帳號',
      emailPlaceholder: '輸入電子郵件地址',
      firstNamePlaceholder: '名',
      lastNamePlaceholder: '姓',
      active: '啟用（可登入）',
      cancel: '取消',
      create: '建立管理員',
      creating: '建立中...',
      notifications: {
        createSuccess: '已成功建立管理員',
        createError: '建立管理員失敗'
      }
    },
    modal: {
      title: '管理管理員 - {{username}}',
      tabs: {
        edit: '編輯管理員',
        permissions: '權限設定'
      },
      info: {
        title: '權限設定說明',
        description: '設定此管理員可存取的模組與可執行的操作。'
      },
      fields: {
        username: '帳號',
        email: '電子郵件',
        firstName: '名',
        lastName: '姓',
        active: '啟用'
      },
      permissions: {
        create: '新增',
        read: '讀取',
        update: '更新',
        delete: '刪除',
        manage: '管理'
      },
      modules: {
        dashboard: '儀表板',
        admins: '管理員管理',
        members: '會友管理',
        events: '活動管理',
        attendance_records: '出席記錄',
        attendance_checkin: '出席報到',
        tithe_receipts: '奉獻收據管理',
        forms: '表單管理',
        posts: '文章管理',
        joomla: 'Joomla 整合'
      },
      noChangesTitle: '沒有變更',
      noChangesMsg: '沒有任何變更可供更新。',
      save: '儲存變更',
      saving: '儲存中...',
      cancel: '取消',
      notifications: {
        updateSuccess: '已成功更新管理員',
        updateError: '更新管理員失敗',
        permsSuccess: '已成功更新權限',
        permsError: '更新權限失敗'
      }
    }
  },
  tithe: {
    secureNotice: '安全奉獻管理 - 已啟用 Bearer Token 驗證',
    title: '奉獻收據管理',
    refresh: '重新整理',
    searchPlaceholder: '以姓名、電話、崇拜編碼、銀行搜尋...',
    filters: {
      statusAll: '全部狀態',
      statusPending: '待審核',
      statusApproved: '已通過',
      statusRejected: '已拒絕',
      yearAll: '全部年份',
      monthAll: '全部月份',
      month01: '一月',
      month02: '二月',
      month03: '三月',
      month04: '四月',
      month05: '五月',
      month06: '六月',
      month07: '七月',
      month08: '八月',
      month09: '九月',
      month10: '十月',
      month11: '十一月',
      month12: '十二月',
      perPage: '每頁 {{count}} 筆'
    },
    stats: {
      monthlyTitle: '本月 ({{month}})',
      allTime: '全部期間',
      receipts: '收據數',
      pending: '待審核',
      approved: '已通過',
      totalAmount: '總金額'
    },
    table: {
      receiptInfo: '收據資訊',
      contact: '聯絡資料',
      payment: '付款資訊',
      amount: '金額',
      status: '狀態',
      actions: '操作',
      worship: '崇拜編碼：',
      createdAt: '建立時間：',
      emailMissing: '無電郵',
      statusLabel: {
        pending: '待審核',
        approved: '已通過',
        rejected: '已拒絕'
      },
      view: '查看',
      approve: '通過',
      reject: '拒絕',
      download: '下載',
      breakdown: {
        tithe: '奉獻',
        building: '建堂基金',
        thanksgiving: '感恩奉獻',
        loveFund: '愛鄰舍基金'
      }
    },
    pagination: {
      showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆',
      previous: '上一頁',
      next: '下一頁',
      pageOf: '第 {{page}} / {{total}} 頁'
    },
    empty: {
      none: '目前沒有奉獻收據',
      adjust: '可嘗試調整搜尋條件'
    },
    notifications: {
      fetchError: '取得奉獻收據失敗',
      statsError: '取得統計資料失敗',
      statusUpdated: '收據已{{status}}',
      statusError: '更新狀態失敗',
      receiptError: '取得收據詳情失敗',
      downloadStarted: '開始下載收據檔案',
      downloadError: '下載收據檔案失敗'
    }
  },
  events: {
    secureNotice: '安全活動管理 - 已啟用 Bearer Token 驗證',
    title: '活動管理',
    tabs: {
      worship: '常規崇拜',
      course: '課程',
      cellGroup: '小組',
      meeting: '會議',
      event: '活動'
    },
    table: {
      id: 'ID',
      eventName: '活動名稱',
      venue: '地點',
      lecturer: '講員',
      sections: '分班',
      nextSection: '下次進行',
      created: '建立時間',
      actions: '操作',
      noEvents: '找不到活動。建立您的第一個活動！',
      noMatch: '找不到符合搜尋的活動。'
    },
    actions: {
      manage: '管理',
      duplicate: '複製',
      delete: '刪除',
      create: '建立{{type}}'
    },
    filters: {
      searchPlaceholder: '搜尋{{type}}...',
      searchWorships: '搜尋崇拜服務...',
      searchCourses: '搜尋課程...',
      searchCellGroups: '搜尋小組...',
      searchMeetings: '搜尋會議...',
      searchEvents: '搜尋活動...',
      from: '從:',
      to: '到:',
      clearFilter: '清除日期篩選',
      perPage: '每頁 {{count}} 筆'
    },
    pagination: {
      showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆活動',
      previous: '上一頁',
      next: '下一頁'
    },
    loading: '載入活動中...',
    error: '載入活動失敗',
    retry: '重試',
    management: {
      worship: '常規崇拜管理',
      course: '課程管理',
      cellGroup: '小組管理',
      meeting: '會議管理',
      event: '活動管理'
    },
    modal: {
      createTitle: '建立新活動',
      editTitle: '編輯活動',
      eventInfo: '活動資訊',
      eventName: '活動名稱 *',
      eventNamePlaceholder: '輸入活動名稱',
      eventType: '活動類型 *',
      venue: '地點',
      venuePlaceholder: '輸入地點',
      mainLecturer: '主講員',
      mainLecturerPlaceholder: '輸入主講員名字',
      mainLecturerNote: '（未在分班中指定時使用）',
      defaultQuantity: '預設數量',
      defaultQuantityPlaceholder: '輸入預設數量',
      defaultQuantityNote: '（應用於所有分班，除非另行指定）',
        attachForm: '附加表單',
        attachFormNone: '-- 無 --',
        attachFormEdit: '編輯',
        attachFormResults: '查看結果',
        remark: '備註',
      remarkPlaceholder: '輸入備註或額外說明',
      sectionsTitle: '分班/課堂',
      addSection: '新增分班',
      sectionName: '分班名稱（可選）',
      sectionNamePlaceholder: '例如：早堂、A班',
      lecturer: '講員',
      lecturerPlaceholder: '例如：John Doe, Jane Smith',
      quantity: '數量',
      quantityPlaceholder: '輸入數量',
      startTime: '開始時間 *',
      startTimePlaceholder: '選擇開始日期和時間',
      endTime: '結束時間 *',
      endTimePlaceholder: '選擇結束日期和時間',
      dragHandle: '拖動以排序',
      removeSection: '移除分班',
      noSections: '至少需要一個分班',
      errors: {
        eventNameRequired: '活動名稱為必填',
        startTimeRequired: '開始時間為必填',
        endTimeRequired: '結束時間為必填',
        endTimeAfterStart: '結束時間必須在開始時間之後'
      },
      buttons: {
        save: '儲存變更',
        saving: '儲存中...',
        create: '建立活動',
        cancel: '取消'
      }
    },
    confirmations: {
      deleteTitle: '刪除活動？',
      deleteMessage: '確定要刪除「{{name}}」嗎？這將刪除所有相關分班。',
      duplicateTitle: '複製活動？',
      duplicateMessage: '確定要複製「{{name}}」嗎？複製版本將附加「(複本)」到名稱。',
      noChangesTitle: '沒有變更',
      noChangesMsg: '沒有任何變更可供更新。'
    },
    notifications: {
      createSuccess: '已成功建立活動',
      updateSuccess: '已成功更新活動',
      duplicateSuccess: '已成功複製活動',
      deleteSuccess: '已成功刪除活動',
      error: '{{action}}活動失敗'
    },
    eventTypes: {
      worship: 'Regular Worship 常規崇拜',
      course: 'Course 課程',
      cellGroup: 'Cell Group 小組',
      meeting: 'Meeting 會議',
      event: 'Event 活動'
    }
  },
  dashboard: {
    secureNotice: 'Secure Admin Dashboard - Bearer token authentication enabled',
    welcomeTitle: '歡迎回來，{{name}}！👋',
    welcomeSubtitle: '以下是您的 CCBC 平台今天的統計與動態。',
    vsLastMonth: '與上月相比',
    recentActivitiesTitle: '最近活動',
    quickActions: '快捷操作',
    systemStatus: '系統狀態',
    stats: {
      totalAdmins: '總管理員數',
      platformPosts: '平台文章',
      joomlaArticles: 'Joomla 文章',
      activeSessions: '活躍工作階段'
    },
    navDebug: {
      title: '導航調試',
      currentUser: '當前用戶:',
      testLinks: '測試直接連結（點擊以測試導航）:',
      hint: '如果這些連結不起作用，請檢查瀏覽器控制台的錯誤。'
    },
    activities: {
      login: '管理員登入',
      create: '新文章建立',
      update: '管理員資料已更新',
      system: '系統備份完成'
    },
    time: {
      justNow: '剛剛',
      twoHoursAgo: '2 小時前',
      oneDayAgo: '1 天前',
      twoDaysAgo: '2 天前'
    },
    actions: {
      addAdmin: '新增管理員',
      newPost: '新文章',
      viewStats: '檢視統計',
      settings: '設定'
    },
    status: {
      backend: 'FastAPI 後端',
      database: 'MySQL 資料庫',
      cms: 'Joomla CMS',
      operational: '正常運作',
      connected: '已連接',
      accessible: '可存取'
    }
  },
  titheReceipts: {
    secureNotice: '安全奉獻管理 - 已啟用 Bearer Token 驗證',
    headerTitle: '奉獻收據管理',
    headerSubtitle: '管理奉獻收據與捐獻記錄',
    createNew: '新增收據',
    refresh: '重新整理',
    form: {
      createTitle: '新增奉獻收據',
      personalInfo: '個人資料',
      addressInfo: '地址資料',
      paymentInfo: '付款資料',
      donationBreakdown: '捐獻明細',
      receiptOptions: '收據選項',
      uploadReceipt: '上傳收據檔案',
      remarks: '備註',
      chineseName: '中文姓名',
      englishName: '英文姓名',
      contactPhone: '聯絡電話',
      email: '電郵',
      worshipCode: '崇拜編碼',
      address: '地址',
      district: '地區',
      area: '區域',
      receivingBank: '收款銀行',
      transactionType: '交易類型',
      depositDate: '入數日期',
      referenceNumber: '參考編號',
      tithe: '當納十分一',
      thanksgiving: '感恩奉獻',
      churchOperating: '教會經常費',
      buildingFund: '建堂基金',
      gospelMinistry: '福音事工',
      loveNeighbor: '愛鄰舍基金',
      specialOffering: '特別奉獻',
      specialOfferingDesc: '特別奉獻說明',
      otherOffering: '其他',
      otherOfferingDesc: '其他（請註明）',
      otherOfferingPlaceholder: '請註明其他奉獻用途…',
      totalAmount: '總金額',
      receiptRequired: '需要收據',
      receiptType: '收據類型',
      receiptIndependent: '獨立收據',
      receiptYearly: '全年收據',
      receiptLanguage: '收據語言',
      selectFile: '收據檔案（PDF、JPEG、PNG，最大 5MB）',
      selectedFile: '已選：{{name}}',
      create: '建立收據',
      creating: '建立中…',
      cancel: '取消',
      createdSuccess: '已成功建立奉獻收據 #{{id}}',
      createError: '建立奉獻收據失敗',
      validationRequired: '請填寫中文姓名及聯絡電話',
      validationAmount: '至少一項奉獻金額須大於 0'
    },
    stats: {
      thisMonth: "本月 ({{month}})",
      allTime: '全部期間',
      receipts: '收據數',
      pending: '待審核',
      approved: '已通過',
      totalAmount: '總金額'
    },
    controls: {
      searchPlaceholder: '以姓名、電話、崇拜編碼、銀行搜尋...',
      status: {
        all: '全部狀態',
        pending: '待審核',
        approved: '已通過',
        rejected: '已拒絕'
      },
      year: { all: '全部年份' },
      month: {
        all: '全部月份',
        m01: '一月', m02: '二月', m03: '三月', m04: '四月', m05: '五月', m06: '六月',
        m07: '七月', m08: '八月', m09: '九月', m10: '十月', m11: '十一月', m12: '十二月'
      },
      perPage: '每頁 {{count}} 筆'
    },
    table: {
      receiptInfo: '收據資訊',
      contact: '聯絡資料',
      paymentDetails: '付款資訊',
      amount: '金額',
      status: '狀態',
      actions: '操作',
      worship: '崇拜編碼',
      noEmail: '無電郵',
      statusLabel: {
        pending: '待審核',
        approved: '已通過',
        rejected: '已拒絕'
      }
    },
    actions: {
      view: '查看',
      approve: '通過',
      reject: '拒絕',
      download: '下載'
    },
    statuses: { pending: '待審核', approved: '已通過', rejected: '已拒絕' },
    pagination: {
      showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆',
      previous: '上一頁',
      next: '下一頁',
      pageOf: '第 {{page}} / {{total}} 頁'
    },
    empty: {
      noResults: '目前沒有奉獻收據',
      tryAdjustSearch: '可嘗試調整搜尋條件'
    },
    notifications: {
      fetchError: '取得奉獻收據失敗',
      statsError: '取得統計資料失敗',
      statusUpdatedTitle: '狀態已更新',
      statusUpdatedMsg: '收據已{{status}}',
      downloadStartedTitle: '開始下載',
      downloadStartedMsg: '開始下載收據檔案',
      downloadErrorTitle: '下載錯誤',
      downloadErrorMsg: '下載收據檔案失敗'
    },
    modal: {
      title: '奉獻收據 #{{id}}',
      status: '狀態',
      created: '建立時間:',
      close: '關閉',
      personalInfo: '個人資訊',
      addressInfo: '地址資訊',
      paymentInfo: '付款資訊',
      donationBreakdown: '捐獻明細',
      additionalInfo: '額外資訊',
      approve: '通過',
      approveSubmit: '通過',
      approveConfirm: '確定要通過此奉獻收據嗎？',
      reject: '拒絕',
      rejectSubmit: '拒絕',
      rejectConfirm: '請提供拒絕此奉獻收據的原因:',
      remarks: '備註',
      fields: {
        chineseName: '中文名字',
        englishName: '英文名字',
        contactPhone: '聯絡電話',
        email: '電子郵件',
        worshipCode: '崇拜編碼',
        address: '地址',
        district: '地區',
        area: '地區/國家',
        receivingBank: '收款銀行',
        transactionType: '交易類型',
        depositDate: '存款日期',
        referenceNumber: '參考編號',
        tithe: '奉獻額',
        titheAmount: '奉獻額',
        thanksgiving: '感恩奉獻',
        churchOperating: '教會經常費',
        buildingFund: '建堂基金',
        gospelMinistry: '福音事工',
        loveNeighbor: '愛鄰舍基金',
        specialOffering: '特別奉獻',
        specialOfferingDesc: '特別奉獻說明',
        otherOffering: '其他',
        otherOfferingDesc: '其他（請註明）',
        totalAmount: '總金額',
        receiptRequired: '需要收據',
        receiptType: '收據類型',
        receiptIndependent: '獨立收據',
        receiptYearly: '全年收據',
        yes: '是',
        no: '否',
        languagePreference: '語言偏好',
        uploadedReceipt: '已上傳收據',
        remarks: '備註',
        processedBy: '處理者',
        processedAt: '處理時間'
      }
    }
  },
  organization: {
    title: '組織架構管理',
    subtitle: '牧區 → 分區 → 小組',
    legend: {
      district: '牧區',
      zone: '分區',
      group: '小組'
    },
    loading: '載入組織架構資料...',
    error: '無法載入組織架構資料。',
    reload: '重新載入',
    addFirst: '新增第一個區域',
    empty: '暫無組織架構',
    filters: {
      districtLabel: '牧區:',
      zoneLabel: '分區:',
      groupLabel: '小組:',
      districtPlaceholder: '搜尋牧區...',
      zonePlaceholder: '搜尋分區...',
      groupPlaceholder: '搜尋小組...',
      districtEmpty: '找不到牧區',
      zoneEmpty: '找不到分區',
      groupEmpty: '找不到小組',
      clearAll: '清除篩選'
    },
    actions: {
      addDistrict: '新增牧區',
      addZone: '新增分區',
      addGroup: '新增小組',
      manageMembers: '管理組員',
      edit: '編輯',
      delete: '刪除',
      groupCount: '{{count}} 小組',
      zoneCount: '{{count}} 分區'
    },
    badges: {
      district: '牧區',
      zone: '分區',
      group: '小組'
    },
    detail: {
      districtManager: '牧區長:',
      zoneManager: '區長:',
      groupManager: '組長:',
      noneAssigned: '未指派'
    },
    stats: {
      core: '核心組員',
      full: '正式組員',
      associate: '侯任組員',
      total: '總數'
    },
    confirmDelete: '確定要刪除此{{type}}嗎？',
    confirmRemoveMember: '確定移除這位組員嗎？',
    deleteError: '刪除失敗，請稍後再試。',
    saveError: '儲存失敗，請稍後再試。',
    removeError: '移除組員失敗。',
    duplicateName: '{{type}}「{{name}}」已存在，請使用其他名稱',
    emptyName: '{{type}}名稱不能為空',
    types: {
      district: '牧區',
      zone: '分區',
      group: '小組',
      districtManager: '牧區長',
      zoneManager: '區長',
      groupManager: '組長'
    },
    modal: {
      createTitle: '新增',
      editTitle: '編輯',
      parentLabel: '上級{{parent}}',
      nameLabel: '{{type}}名稱 *',
      namePlaceholder: '例如：{{type}} 名稱',
      managerLabel: '{{manager}}',
      loadingMembers: '載入會員中...',
      searchManager: '搜尋{{manager}}姓名或編號，或直接輸入名稱...',
      managerHint: '可選擇會員或直接輸入非會員名稱',
      moreMembers: '還有 {{count}} 位會員...',
      noMembers: '找不到符合的會員',
      description: '描述',
      descriptionPlaceholder: '選填',
      cancel: '取消',
      save: '儲存'
    },
    membersModal: {
      title: '{{group}} 組員管理',
      summaryCore: '核心: {{count}}',
      summaryFull: '正式: {{count}}',
      summaryAssociate: '侯任: {{count}}',
      addLabel: '新增組員',
      searchPlaceholder: '搜尋會員姓名或編號...',
      loadingMembers: '載入會員中...',
      moreMembers: '還有 {{count}} 位會員...',
      noMembers: '找不到符合的會員',
      roleCore: '核心組員',
      roleFull: '正式組員',
      roleAssociate: '侯任組員',
      addButton: '加入',
      loadingAssignments: '載入中...',
      empty: '目前尚未有組員',
      worshipId: '崇拜編碼: {{id}}',
      worshipMissing: '未提供崇拜編碼',
      remove: '移除',
      saveAll: '儲存變更',
      close: '關閉',
      addSuccess: '組員新增成功',
      addError: '新增組員失敗',
      roleSuccess: '角色更新成功',
      roleError: '更新角色失敗',
      removeError: '移除組員失敗',
      coreForbiddenForLeader: '區牧、區長、組長不能同時為核心組員'
    }
  },
  attendance: {
    secureNotice: '安全出席記錄管理 - 已啟用 Bearer Token 驗證',
    title: '出席記錄',
    tabs: {
      worship: '常規崇拜',
      course: '課程',
      cellGroup: '小組',
      meeting: '會議',
      event: '活動'
    },
    header: {
      regularWorship: '常規崇拜',
      course: '課程',
      cellGroup: '小組',
      meeting: '會議',
      events: '活動',
      attendanceRecords: '出席記錄'
    },
    filters: {
      from: '從:',
      to: '到:',
      clearDateFilter: '清除日期篩選',
      eventType: '活動類型',
      selectEvent: '選擇活動',
      selectSection: '選擇分班',
      perPage: '每頁 {{count}} 筆',
      search: '以會友姓名或崇拜編碼搜尋...'
    },
    memberFilter: {
      title: '所有出席記錄',
      subtitle: '跨所有活動類型，以日期、活動或分班等篩選查看記錄',
      filtersApplied: '已套用 {{count}} 個篩選',
      clearAll: '清除全部篩選',
      memberLabel: '會友',
      memberPlaceholder: '輸入 2 個字元以上搜尋會友...',
      memberSearchError: '目前無法載入會友建議',
      clearMember: '清除會友',
      selected: '已選擇：{{member}}',
      resultSummary: '{{count}} 筆 · {{dateRange}} · {{member}}',
      noDateRange: '未選日期範圍',
      anyone: '任何會友',
      unknownMember: '未知會友',
      excused: '告假',
      notAttended: '未出席',
      attended: '已出席'
    },
    table: {
      worshipId: '崇拜編碼',
      mobilePhone: '手機號碼',
      memberName: '會友名字',
      event: '活動',
      section: '分班',
      checkInTime: '報到時間',
      qrTime: 'QR 時間',
      status: '狀態',
      actions: '操作'
    },
    actions: {
      view: '查看',
      edit: '編輯',
      delete: '刪除',
      createRecord: '建立記錄'
    },
    status: {
      present: '到場',
      absent: '缺席',
      late: '遲到'
    },
    confirmDelete: '確定要刪除崇拜編碼 {{id}} 的出席記錄嗎？',
    loading: '載入出席記錄中...',
    error: '載入出席記錄失敗',
    noRecords: '找不到出席記錄',
    notifications: {
      deleteSuccess: '已成功刪除出席記錄',
      deleteError: '刪除出席記錄失敗',
      updateSuccess: '已成功更新出席記錄',
      updateError: '更新出席記錄失敗'
    },
    pagination: {
      showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆記錄',
      previous: '上一頁',
      next: '下一頁'
    },
    modal: {
      title: '出席記錄',
      close: '關閉'
    }
  },
  checkIn: {
    secureNotice: '安全報到管理 - 已啟用 Bearer Token 驗證',
    title: 'QR 報到',
    selectEvent: '選擇活動',
    selectSection: '選擇分班',
    noEvents: '沒有可用活動',
    noSections: '沒有可用分班',
    scannerType: '掃描器類型',
    scannerTypeUniversal: '通用掃描器',
    scannerTypeYudiel: 'Yudiel QR 掃描器',
    startScanning: '開始掃描',
    stopScanning: '停止掃描',
    keepRunning: '保持掃描器運行',
    manualInput: '手動輸入',
    enterQRCode: '輸入 QR Code 或崇拜編碼',
    submit: '提交',
    diagnostics: '顯示診斷',
    recentScans: '最近掃描',
    scanResult: '掃描結果',
    noScans: '尚未有掃描',
    error: '錯誤',
    success: '成功',
    loading: '載入中...',
    selectEventSection: '選擇活動及分班',
    qrCodeScanner: 'QR Code 掃描器',
    checkInAttendance: '報到 (QR 掃描)',
    scanInstructions: '選擇活動和分班，然後掃描 QR Code 進行報到。',
    notifications: {
      checkInSuccess: '報到成功',
      checkInError: '報到失敗',
      invalidQR: '無效的 QR code',
      worshipNotFound: '找不到崇拜編碼',
      selectionRequired: '需要選擇',
      selectionMessage: '開始掃描前，請選擇活動和分班。'
    },
    messages: {
      selectEventFirst: '請先選擇活動',
      selectSectionFirst: '請先選擇分班',
      scanningStarted: '已開始掃描',
      scanningStopped: '已停止掃描',
      cameraError: '相機存取錯誤',
      cameraNotFound: '找不到相機'
    }
  },
  continuousCheckIn: {
    title: '連續報到',
    description: '連續掃描多個 QR Code，無需停止',
    selectEvent: '選擇活動',
    selectSection: '選擇分班',
    startScanning: '開始掃描',
    stopScanning: '停止掃描',
    scannedCount: '已掃描: {{count}}',
    totalRecords: '總記錄數',
    noRecords: '尚未有掃描',
    messages: {
      selectEventFirst: '請先選擇活動',
      selectSectionFirst: '請先選擇分班',
      scanningStarted: '已開始掃描',
      scanningStopped: '已停止掃描'
    },
    notifications: {
      checkInSuccess: '報到成功',
      checkInError: '報到失敗',
      invalidQR: '無效的 QR code'
    }
  },
  forms: {
    list: {
      title: '表單管理',
      create: '建立表單',
      searchPlaceholder: '搜尋表單...',
      perPage: '顯示 {{count}} 筆',
      table: {
        formName: '表單名稱',
        slug: '代碼',
        status: '狀態',
        actions: '操作'
      },
      actions: {
        edit: '編輯',
        submissions: '提交記錄',
        view: '查看',
        delete: '刪除'
      },
      status: {
        active: '啟用',
        draft: '草稿',
        archived: '已封存'
      },
      empty: '尚無表單。',
      emptySearch: '找不到符合搜尋的表單。',
      pagination: {
        showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 個表單',
        previous: '上一頁',
        next: '下一頁'
      },
      confirmDelete: '這將永久刪除表單「{{name}}」及所有提交記錄。確定繼續？',
      deleteError: '刪除表單失敗'
    },
    builder: {
      createTitle: '建立表單',
      editTitle: '編輯表單',
      errorLoading: '載入表單錯誤',
      labels: {
        name: '名稱',
        slug: '代碼',
        description: '描述',
        status: '狀態',
        openAt: '開放時間',
        closeAt: '關閉時間'
      },
      placeholders: {
        openAtNote: '留空表示立即開放。',
        closeAtNote: '留空表示永不自動關閉。'
      },
      statusOptions: {
        draft: '草稿',
        published: '已發佈',
        archived: '已封存'
      },
      tabs: {
        builder: '視覺編輯器',
        json: 'JSON'
      },
      palette: {
        title: '新增欄位',
        formTitle: '表單標題',
        formTitleEn: '表單標題 (EN)',
        formTitleTc: '表單標題 (中文)'
      },
      canvas: {
        dragInstruction: '拖曳以重新排序欄位',
        empty: '尚無欄位。從左側新增。'
      },
      inspector: {
        title: '欄位設定',
        empty: '選擇欄位以編輯',
        labels: {
          label: '標籤',
          labelEn: '標籤 (EN)',
          labelTc: '標籤 (中文)',
          key: '鍵值',
          type: '類型',
          required: '必填',
          placeholder: '預設提示 (EN)',
          placeholderTc: '預設提示 (中文)',
          options: '選項（逗號分隔）',
          optionsEn: '選項 EN（逗號分隔）',
          optionsTc: '選項中文（逗號分隔）'
        },
        removeField: '移除欄位'
      },
      fieldTypes: {
        text: '文字',
        email: '電子郵件',
        number: '數字',
        date: '日期',
        textarea: '多行文字',
        select: '下拉選單',
        multiselect: '多選下拉',
        radio: '單選按鈕',
        checkbox: '核取方塊',
        file: '檔案'
      },
      jsonNote: '結構: { title: string, fields: [{ key, label, type, required?, options? }] }',
      invalidJson: '無效的 JSON',
      buttons: {
        save: '儲存表單',
        saving: '儲存中...',
        cancel: '取消'
      },
      errors: {
        failedToLoad: '載入表單失敗',
        failedToSave: '儲存表單失敗'
      }
    },
    submissions: {
      title: '表單提交記錄',
      exportCsv: '匯出 CSV',
      dropForm: '刪除表單',
      searchPlaceholder: '搜尋提交記錄...',
      perPage: '顯示 {{count}} 筆',
      table: {
        id: 'ID',
        created: '建立時間',
        submitterEmail: '提交者電郵',
        noEmail: '-'
      },
      empty: '尚無提交記錄',
      emptySearch: '找不到符合搜尋的提交記錄。',
      pagination: {
        showing: '顯示第 {{from}} - {{to}} 筆，共 {{total}} 筆提交記錄',
        previous: '上一頁',
        next: '下一頁'
      },
      confirmDelete: '這將永久刪除表單「{{name}}」及所有提交記錄。確定繼續？',
      exportError: '匯出失敗',
      deleteError: '刪除表單失敗',
      errorLoading: '載入提交記錄錯誤',
      loadError: '載入提交記錄失敗'
    }
  },
  titheSubmission: {
    title: '奉獻提交',
    subtitle: '向教會提交你的奉獻',
    successMessage: '感謝！你的奉獻已收到。我們將盡快處理。',
    personalInfo: '個人資訊',
    paymentInfo: '付款資訊',
    donationAmounts: '奉獻金額',
    additionalInfo: '額外資訊',
    totalAmount: '總金額',
    selectBank: '選擇收款銀行',
    selectTransactionType: '選擇交易方式',
    submit: '提交奉獻',
    submitting: '提交中...',
    fields: {
      chineseName: '中文名字',
      worshipCode: '崇拜編碼',
      worshipCodeOptional: '（選項 - 非教友可留空）',
      contactPhone: '聯絡電話',
      email: '電子郵件',
      receivingBank: '收款銀行',
      transactionType: '交易方式',
      depositDate: '存款日期及時間',
      tithe: '奉獻',
      thanksgiving: '感恩奉獻',
      churchOperating: '教會經常費',
      buildingFund: '建堂基金',
      gospelMinistry: '福音事工',
      loveNeighbor: '愛鄰舍基金',
      specialOffering: '特別奉獻',
      specialOfferingDesc: '特別奉獻說明',
      receiptRequired: '我需要奉獻收據',
      receiptFrequency: '收據偏好',
      receiptFrequencyPerSubmission: '每次提交都發出收據',
      receiptFrequencyYearly: '每年合併發出一張收據',
      receiptFrequencyHint: '請選擇你希望收取收據的方式。',
      remarks: '額外備註',
      remarksPlaceholder: '請在此提供任何額外資訊或特殊指示...',
      uploadReceipt: '上傳收據（PDF/JPG/PNG）',
      uploadHint: '選填。接受 PDF、JPG、PNG。'
    },
    errors: {
      nameRequired: '請輸入你的名字',
      phoneRequired: '請輸入你的聯絡電話',
      bankRequired: '請選擇收款銀行',
      transactionTypeRequired: '請選擇交易方式',
      depositDateRequired: '請選擇存款日期及時間',
      amountRequired: '請輸入至少一項奉獻金額',
      invalidFileType: '只接受 PDF、JPG 或 PNG 檔案',
      uploadFailed: '上傳收據附件失敗，請再試一次。',
      submitFailed: '提交奉獻失敗。請重試。'
    }
  }
};
